module.exports = __webpack_public_path__ + "static/media/tarjeta_no_valida.53805a2f.svg";